import { computed, inject, Injectable } from '@angular/core';
import { ModulesStore } from '../../features/admin/modules/modules.store';
import { UserPreferenceStore } from '../../core/services/user-preference/user-preference.store';
import { EntriesService } from '../../features/admin/modules/features/entries/entries.service';
import type { Module } from '../../features/admin/modules/modules.model';
import { FormService } from '../../features/admin/modules/features/form-builder/form.service';
import { UtilityService } from './utility.service';
import { cloneDeep } from 'lodash-es';
import { debugLog } from 'app/shared/utils/debug-logger';

@Injectable({
  providedIn: 'root',
})
export class MigrateService {
  modulesStore = inject(ModulesStore);
  entriesService = inject(EntriesService);
  formService = inject(FormService);
  utilityService = inject(UtilityService);
  userPreferenceStore = inject(UserPreferenceStore);
  loaded = computed(() => {
    if (this.modulesStore.modulesLoaded()) {
      debugLog('Migrate', 'Modules loaded');
      if (this.modulesStore.actionsLoaded()) {
        debugLog('Migrate', 'Actions loaded');
        // this.updateActions();
      }
      if (this.modulesStore.settingsLoaded()) {
        debugLog('Migrate', 'Settings loaded');
        // this.updateSettings();
      }
      if (this.userPreferenceStore.loaded()) {
        debugLog('Migrate', 'User preference loaded');
        // this.updateUserSettings();
      }

      const modules = cloneDeep(this.modulesStore.modules());

      // modules.forEach((module, index) => {
      // console.log(module);
      // module.sourceForm.map(field => {
      //   field.lock = true;
      //   console.log(field);
      //   return field;
      // });
      //
      // console.log(module.sourceForm);
      // if (!skip) {
      //   setTimeout(() => {
      //     this.modulesStore.edit({
      //       id: module.id,
      //       data: module,
      //     });
      //   }, 1000 * index);
      // }
      // });

      // this.updateTaxonomies();
      // this.updateEntitiesValue('filters', {});
      // this.updatePageValue('filters', {});
      // this.updateEntriesValue();
      // this.updateGeneratedForms();
    }
  });
  constructor() {
    // console.log('migrate service loaded');
  }

  updateGeneratedForms() {
    const modules = cloneDeep(this.modulesStore.modules());

    modules.forEach((entity, index) => {
      // Apply lock attribute recursively to all fields
      const applyLockToFields = fields => {
        if (!Array.isArray(fields)) return;

        fields.forEach(field => {
          // Set lock property on current field
          field.lock = true;
          if (field.type === 'linked-items') {
            field.lock = false;
          }

          // Find child fields in any of the possible container types
          const childFields =
            field.groupFields ||
            field.accordionFields ||
            field.sectionFields ||
            field.tabsFields ||
            field.pagesFields ||
            field.wizardFields ||
            field.repeatFields;

          // Recursively process child fields if they exist
          if (childFields) {
            applyLockToFields(childFields);
          }
        });
      };

      // Apply lock to all fields in the source form
      applyLockToFields(entity.sourceForm);

      // Schedule update with delay
      setTimeout(() => {
        this.modulesStore.edit({
          id: entity.id,
          data: entity,
        });
      }, index * 100);
    });

    debugLog('Migrate', 'updateGeneratedForms modules:', modules);
    debugLog('Migrate', 'migrate function for generating forms loaded');
  }

  updateEntitiesValue(target: string, value: any) {
    this.modulesStore.entities().forEach((entity, index) => {
      setTimeout(() => {
        this.modulesStore.edit({
          id: entity.id,
          data: {
            ...entity,
            // usersKeyPaths: [entity?.['employeeKeyPath']],
            // companiesKeyPaths: [{ company: entity['clientKeyPath'], location: '' }],
            clientKeyPath: undefined,
            // [target]: value,
          } as Module,
        });
      }, index * 100);
    });
    debugLog('Migrate', 'migrate function for updating entities loaded');
  }

  updatePageValue(target: string, value: any) {
    this.modulesStore.pages().forEach((page, index) => {
      setTimeout(() => {
        this.modulesStore.edit({
          id: page.id,
          data: {
            ...page,
            // [target]: value,
          },
        });
      }, index * 100);
    });
    debugLog('Migrate', 'migrate function for updating page loaded');
  }

  updateActions() {
    this.modulesStore.modules().forEach(module => {
      this.modulesStore.actions()[module.id].forEach((action, index) => {
        setTimeout(() => {
          this.modulesStore.editAction({
            moduleId: module.id,
            actionId: action.id,
            data: action,
          });
        }, index * 100);
      });
    });
    debugLog('Migrate', 'migrate function for updating actions loaded');
  }

  updateTaxonomies() {
    this.modulesStore.modules().forEach(module => {
      this.modulesStore.taxonomies()[module.id].forEach((taxonomy, index) => {
        setTimeout(() => {
          this.modulesStore.editTaxonomy({
            moduleId: module.id,
            taxonomyId: taxonomy.id,
            data: taxonomy,
          });
        }, index * 100);
      });
    });
    debugLog('Migrate', 'migrate function for updating taxonomies loaded');
  }

  updateSettings() {
    this.modulesStore.modules().forEach((module, index) => {
      setTimeout(() => {
        const data = this.modulesStore.settings()[module.id];
        // No copy when that module's settings failed to load: write nothing rather than a blank document.
        if (!data) return;
        this.modulesStore.editSettings({ moduleId: module.id, data });
      }, index * 100);
    });
    debugLog('Migrate', 'migrate function for updating settings loaded');
  }

  updateUserSettings() {
    // const widgetAreaId = Object.keys(this.userPreferenceStore.userPreference().widgets)[0];
    // const widget = this.userPreferenceStore.userPreference().widgets[widgetAreaId][0];
    // const widgetId = widget.id;
    //
    // this.userPreferenceStore.editWidget({
    //   widgetAreaId: widgetAreaId,
    //   widgetId: widgetId,
    //   data: widget,
    // });
    //
    // console.log('migrate function for updating UserSettings loaded');
  }

  updateEntriesValue() {
    this.modulesStore.entities().forEach(module => {
      this.modulesStore.loadEntries({
        moduleId: module.id,
        offset: 0,
        limit: 5000,
        applyQueryParams: false,
      });
    });

    // wait till all entries are loaded
    setTimeout(() => {
      debugLog('Migrate', 'entries:', this.modulesStore.entries());
      Object.keys(this.modulesStore.entries()).forEach(moduleId => {
        if (this.modulesStore.entries()[moduleId] == null) {
          return;
        }
        this.modulesStore.entries()[moduleId].forEach((entry, index) => {
          // if (entry.entry.active === '') {
          //   const newEntryValue = cloneDeep({ ...entry, entry: { ...entry.entry, archived: '' } });
          //   setTimeout(() => {
          //     this.modulesStore.editEntry({
          //       moduleId: moduleId,
          //       entryId: entry.id,
          //     entry: newEntryValue,
          //     });
          //   }, index * 200);
          // }
        });
      });
    }, 15000);
    debugLog('Migrate', 'migrate function for update entries loaded');
  }
}
